import React, { useEffect, useRef, useState } from 'react';
import { useLang } from '../LangContext';

const stepIcons = [
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"/></svg>,
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>,
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>,
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 16l-4-4h3V4h2v8h3l-4 4z"/><path d="M20 18H4"/></svg>,
];

export default function HowItWorks() {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.15 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!visible) return;
    const interval = setInterval(() => setActiveStep(s => (s + 1) % 4), 2500);
    return () => clearInterval(interval);
  }, [visible]);

  return (
    <section id="panduan" ref={ref} style={{
      padding: '6rem 1.5rem',
      background: 'var(--bg2)',
      borderTop: '1px solid rgba(255,255,255,0.04)',
      borderBottom: '1px solid rgba(255,255,255,0.04)',
    }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <div style={{
            display: 'inline-block',
            background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)',
            borderRadius: '99px', padding: '4px 14px', marginBottom: '1rem',
          }}>
            <span style={{ fontSize: '11px', color: 'var(--text2)', fontWeight: 500, letterSpacing: '0.08em', textTransform: 'uppercase' }}>
              {t.howItWorks.sectionBadge}
            </span>
          </div>
          <h2 style={{
            fontFamily: 'var(--font-display)', fontSize: 'clamp(1.6rem, 4vw, 2.4rem)',
            fontWeight: 800, letterSpacing: '-0.02em', color: 'var(--text)',
          }}>{t.howItWorks.headline}</h2>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '1.5rem' }}>
          {t.howItWorks.steps.map((step, i) => (
            <div key={i} onClick={() => setActiveStep(i)} style={{
              padding: '1.5rem', borderRadius: '14px',
              background: activeStep === i ? 'rgba(255,60,60,0.06)' : 'transparent',
              border: `1px solid ${activeStep === i ? 'rgba(255,60,60,0.2)' : 'rgba(255,255,255,0.06)'}`,
              cursor: 'pointer', transition: 'all 0.3s',
              opacity: visible ? 1 : 0,
              transform: visible ? 'translateY(0)' : 'translateY(20px)',
              transitionDelay: `${i * 0.1}s`,
            }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}>
                <div style={{
                  width: '40px', height: '40px', borderRadius: '10px',
                  background: activeStep === i ? 'var(--brand)' : 'rgba(255,255,255,0.05)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: activeStep === i ? 'white' : 'var(--text2)', transition: 'all 0.3s',
                }}>
                  {stepIcons[i]}
                </div>
                <span style={{
                  fontFamily: 'var(--font-display)', fontSize: '28px', fontWeight: 800,
                  color: activeStep === i ? 'rgba(255,60,60,0.2)' : 'rgba(255,255,255,0.06)',
                  transition: 'color 0.3s',
                }}>{step.num}</span>
              </div>
              <h3 style={{
                fontFamily: 'var(--font-display)', fontSize: '14px', fontWeight: 700,
                color: activeStep === i ? 'var(--text)' : 'var(--text2)',
                marginBottom: '6px', transition: 'color 0.3s',
              }}>{step.title}</h3>
              <p style={{ fontSize: '12px', color: 'var(--text3)', lineHeight: 1.6, fontWeight: 300 }}>{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
